import { nextTick } from "vue";

/**
 * URL do Widget do E-auth
 */
const WIDGET_URL = process.env.MIX_EAUTH_WIDGET_URL;

/**
 * URL da API do E-auth
 */
const EAUTH_URL = process.env.MIX_EAUTH_API_URL?.replace(/\/$/, '') // replace remove "/" do final, caso exista

/**
 * Configuração padrão do widget do E-auth
 *
 * @type {{
 *     containerId: string,
 *     mode: string,
 *     buttonSize: string,
 *     buttonBackground: string,
 *     icon: string,
 *     iconSize: string
 * }}
 */
const DEFAULT_CONFIG = {
    containerId: '',
    mode: '',
    buttonSize: '60',
    buttonBackground: 'var(--color-primary)',
    icon: 'google',
    iconSize: '60',
    iconColor: '#ffffff'
};

/**
 * Armazena o script atual do Widget do E-auth
 */
let currentScript = null;

/**
 * Composable para gerenciar o widget do E-auth
 *
 * @returns {{ mountWidget: mountWidget, removeWidget: removeWidget }}
 */
export function useEauthWidget() {
    /**
     * Remove o widget do E-auth
     */
    function removeWidget() {
        if (currentScript) {
            currentScript.remove();
            currentScript = null;
        }
    }

    /**
     * Monta o widget do E-auth
     *
     * @param customConfig {{
     *     containerId: string,
     *     mode: string,
     *     buttonSize: string,
     *     buttonBackground: string,
     *     icon: string,
     *     iconSize: string
     * }}
     */
    async function mountWidget(customConfig = {}) {
        if (!WIDGET_URL || !EAUTH_URL) return;

        const config = { ...DEFAULT_CONFIG, ...customConfig };

        removeWidget(); // Remove script existente

        await nextTick();

        let container = document.getElementById(config.containerId);

        // Tenta buscar container novamente se ainda não existir
        if (!container) {
            await new Promise(resolve => setTimeout(resolve, 50));

            container = document.getElementById(config.containerId);
        }

        if (!container) {
            console.error('Container para renderizar Widget do E-auth não encontrado:', config.containerId);

            return;
        }

        // Monta e insere novo script

        const script = document.createElement('script');

        script.src = WIDGET_URL;

        script.setAttribute('data-api-url', EAUTH_URL);
        script.setAttribute('data-mode', config.containerId ? 'inline' : config.mode);
        script.setAttribute('data-mount-id', config.containerId);
        script.setAttribute('data-inline-size', config.buttonSize);
        script.setAttribute('data-inline-bg', config.buttonBackground);
        script.setAttribute('data-icon', config.icon);
        script.setAttribute('data-icon-size', config.iconSize);
        script.setAttribute('data-icon-color', config.iconColor);

        document.body.appendChild(script);

        currentScript = script;
    }

    return {
        mountWidget,
        removeWidget
    };
}
